<script setup>
import OsTopbar from 'dashboard/components-next/os/OsTopbar.vue';

// A moldura que o SettingsWrapper dava até agora, refeita aqui porque as telas do
// PowerData saíram de dentro dele. Uma só cópia, usada pelas duas telas: duplicar as
// classes de rolagem em Index e Show seria a segunda cópia que sai de sincronia.
//
// O que vem do SettingsWrapper (modo não-fullHeight) e precisa continuar valendo:
// o fundo `bg-n-background`, o `overflow-auto` de quem rola, o respiro `px-6 pt-4 pb-8`
// e o `items-start`, que deixa a tela de dentro com a altura do próprio conteúdo.
//
// O que é novo: o OsTopbar. Fora do shell não há sidebar, então o caminho de volta tem
// de estar na própria tela — é a mesma barra do PowerAppStandalone, com a seta para a
// Home, a troca de org, idioma, tema e perfil.
defineProps({
  title: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="flex flex-col w-full h-full min-h-0 bg-n-background">
    <OsTopbar show-back-to-home :title="title" />
    <div
      class="flex flex-col flex-1 w-full px-6 pt-4 pb-8 overflow-auto min-h-0"
    >
      <div class="flex items-start w-full">
        <slot />
      </div>
    </div>
  </div>
</template>
